import React from 'react'
import styled from 'styled-components';
import ButtonTC from '../../../../components/button-tc/button-tc';
import { ArrowIosForward } from '@styled-icons/evaicons-solid'

const ContainerDestiny = styled.div`
    margin-left: 6px;
    margin-right: 6px;
    padding-bottom: 10px;
`

const HeaderItemContainer = styled.div<{ image: string }>`
    background-image: url(${props => props.image});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 200px;
    display: flex;
    justify-content: right;
    align-items: flex-start;
    border-radius: 40px 0 40px 0;
`

const ContainerTour = styled.div`
    background: #f3b917;
    width: fit-content;
    border-radius: 100px 0 0 15px;
    color: white;
    display: flex;
    justify-content: right;
    align-items: center;
    padding-right: 50px;
    padding-left: 35px;
    margin-top: 10%;
`
const BodyItemContainer = styled.div`
    > h3{
        color: ${p => p.theme.palette.primary.main};
        margin: 15px 0 0;
    }
    
    > h4{
        color: ${p => p.theme.palette.secondary.main};
        margin: 5px 0;
    }

    > p{
        font-size: 14px;
    }

    > div {
        width: fit-content;
    }
`

interface IOwnProps{
    tour?: string;
    title?: string;
    image: string;
    subTitle?: string;
    description?: string;
}

const DestinyItem: React.FunctionComponent<IOwnProps> = ({
    tour,
    title,
    image,
    subTitle,
    description,
}) => {
  return (
    <ContainerDestiny>
        <HeaderItemContainer image={image}>
            <ContainerTour>{tour}</ContainerTour>
        </HeaderItemContainer>
        <BodyItemContainer>
            <h3>{title}</h3>
            <h4>{subTitle}</h4>
            <p>{description}</p>
            <div>
                <ButtonTC text='Ver más información' icon={<ArrowIosForward />}/>
            </div>
        </BodyItemContainer>
    </ContainerDestiny>
  )
}

export default DestinyItem